import React from 'react'
import { Grid } from '@mui/material'
import FilterAutocomplete from '../../../shared/AutoCompeleteFillter'

const CustomerFilter = ({setFilterValue ,filterValue , userStatus}) => {
    const handleChangeFilter = (newvalue) => {
      //dispatch({type:"FilterCustomers" , payload:newvalue})
        setFilterValue(newvalue)
       }


  return (
    <Grid
    container
    justifyContent="flex-start"
    alignItems="center"
    gap="20px"
    sx={{ 
      padding: "20px 20px 25px 20px",
      
borderBottom: "1px solid #E7E9EF",
background: "#fff",
   }}
  >
    <Grid item>
     
     <FilterAutocomplete
      options={userStatus}
      width={152}
      selectedValue={filterValue}
      fieldName="user Status"
      handleChangeSelection={handleChangeFilter}
   

     />
    
        
     
    </Grid> 
  </Grid>
    )
}

export default CustomerFilter